import React from 'react';
import router, { RouteNode } from '../../config/router';
import ModuleOverview from './ModuleOverview';

const platforms = new RouteNode('Modules', '/modules', <ModuleOverview />);
router.addRoute(platforms);
